import React from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, FlaskConical, TrendingUp, BookOpen, ShieldCheck, Sprout, Leaf, Megaphone, ScrollText, FlaskRound, Flower2 } from "lucide-react";

const NAV_ITEMS = [
  { to: "/admin",                Icon: LayoutDashboard, label: "Overview" },
  { to: "/admin/members",        Icon: Users,           label: "Members" },
  { to: "/admin/prescriptions",  Icon: FlaskConical,    label: "Prescriptions" },
  { to: "/admin/analytics",      Icon: TrendingUp,      label: "Analytics" },
  { to: "/admin/curate",         Icon: BookOpen,        label: "Curation" },
  { to: "/admin/protocols",      Icon: ScrollText,      label: "Protocols" },
  { to: "/admin/apothecary",     Icon: Leaf,            label: "Apothecary" },
  { to: "/admin/social",         Icon: Megaphone,       label: "Social" },
  { to: "/admin/caring",         Icon: Sprout,          label: "Caring for Country" },
  { to: "/admin/womens-vitality", Icon: Flower2,        label: "Women's Vitality" },
  { to: "/admin/audit",          Icon: ShieldCheck,     label: "Audit" },
  { to: "/admin/research",       Icon: FlaskRound,      label: "Research" },
];

export default function AdminLayout({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#F9F6F0]"><Header /><p className="p-20 text-center text-[#5C6359]">…</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen bg-[#F9F6F0]">
        <Header />
        <section className="px-6 sm:px-12 lg:px-20 py-32 max-w-xl mx-auto text-center" data-testid="admin-denied">
          <h1 className="font-serif text-3xl text-[#2D322B]">This steward&apos;s door is closed.</h1>
          <p className="mt-4 text-[#5C6359]">Admin access required.</p>
        </section>
        <Footer />
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <Header />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-10 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-10">
        <aside data-testid="admin-sidebar" className="lg:sticky lg:top-10 lg:self-start">
          <p className="label-eyebrow mb-5">Steward Console</p>
          <nav className="space-y-1">
            {NAV_ITEMS.map(({ to, Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/admin"}
                data-testid={`admin-nav-${label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 text-sm transition-colors rounded ${isActive ? "bg-[#2D322B] text-[#F9F6F0]" : "text-[#5C6359] hover:text-[#2D322B] hover:bg-[#F1ECE4]"}`
                }
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
                {label}
              </NavLink>
            ))}
          </nav>
          <Link to="/dashboard" className="mt-8 inline-block text-xs uppercase tracking-[2px] text-[#9A8F7E] hover:text-[#C05C42]">
            ← Member view
          </Link>
        </aside>
        <main data-testid="admin-main">{children}</main>
      </div>
      <Footer />
    </div>
  );
}
